<template>
  <b-modal
    ref="loginModal"
    centered
    modal-class="toss-login-modal"
    header-class="toss-modal-header"
    body-class="toss-modal-body"
    footer-class="toss-modal-footer"
    hide-footer
  >
    <!-- Custom Header -->
    <template #modal-header>
      <div class="modal-header-wrapper">
        <h2 class="modal-title">로그인</h2>
        <button type="button" class="close-btn" @click="close">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
    </template>

    <!-- Modal Body -->
    <div class="login-container">
      <div class="welcome-text">
        <p>디비로봇에 오신 것을 환영합니다</p>
      </div>

      <div class="form-group">
        <label class="input-label">아이디</label>
        <div class="input-wrapper">
          <input
            ref="account"
            type="text"
            class="form-input"
            :readonly="isCheck"
            @focusin="isCheck=false"
            v-model="loginModel.account"
            placeholder="아이디를 입력해 주세요"
            @keyup.enter="save"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="input-label">비밀번호</label>
        <div class="input-wrapper">
          <input
            type="password"
            class="form-input"
            :readonly="isCheck"
            @focusin="isCheck=false"
            v-model="loginModel.password"
            placeholder="비밀번호를 입력해 주세요"
            @keyup.enter="save"
          />
        </div>
      </div>

      <div class="remember-section">
        <label class="remember-checkbox">
          <input type="checkbox" v-model="rememberMe">
          <span class="checkbox-mark"></span>
          <span class="checkbox-label">로그인 상태 유지</span>
        </label>
      </div>

      <button
        @click="save"
        class="login-btn"
        :disabled="!loginModel.account || !loginModel.password"
      >
        <span v-if="isLoading">
          <b-spinner small style="margin-right: 8px;"></b-spinner>
          로그인 중...
        </span>
        <span v-else>로그인</span>
      </button>
    </div>
  </b-modal>
</template>

<script>

import {accountAPI} from "@/api";
export default {
  name: "LoginModal",
  props:['loginInit'],
  data(){
    return {
      isCheck: true,
      isLoading: false,
      rememberMe: false,
      loginModel:{
        account:'',
        password:''
      }
    }
  },
  methods:{
    async save(){
      if (!this.loginModel.account || !this.loginModel.password) {
        return;
      }

      this.isLoading = true;
      try {
        const userModel = await this.authStore.login(this.loginModel.account, this.loginModel.password)
        if(userModel.success == true){
          this.loginInit()
          this.close()
          // 현재 페이지 새로고침
          this.$router.go(0)
        }
        else {
          alert(userModel.errorMessage)
        }
      } finally {
        this.isLoading = false;
      }
    },
    open(){
      this.isCheck = true
      this.loginModel = {
        account:'',
        password:''
      }
      this.$refs.loginModal.show()
      setTimeout(() => {
        this.$refs.account.focus();
      }, 200);
    },
    close(){
      this.$refs.loginModal.hide()
    }
  }

}
</script>

<style scoped>
/* Modal Container */
::v-deep .toss-login-modal .modal-dialog {
  max-width: 440px;
  margin: 1.75rem auto;
}

::v-deep .toss-login-modal .modal-content {
  border: none;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
}

::v-deep .toss-modal-header {
  border: none;
  padding: 0;
}

::v-deep .toss-modal-body {
  padding: 0;
}

/* Header */
.modal-header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 0;
  width: 100%;
}

.modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #191f28;
  margin: 0;
  letter-spacing: -0.3px;
}

.close-btn {
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: #8b95a1;
  transition: color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  color: #191f28;
}

/* Body Container */
.login-container {
  padding: 20px 24px 32px;
}

.welcome-text {
  margin-bottom: 28px;
}

.welcome-text p {
  color: #6b7684;
  font-size: 15px;
  margin: 0;
}

/* Form Groups */
.form-group {
  margin-bottom: 20px;
}

.input-label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #333d4b;
}

.input-wrapper {
  position: relative;
}

.form-input {
  width: 100%;
  padding: 14px 16px;
  font-size: 16px;
  border: 1px solid #e5e8eb;
  border-radius: 8px;
  outline: none;
  transition: all 0.2s;
  background: #fff;
}

.form-input:focus {
  border-color: #1e90ff;
  box-shadow: 0 0 0 3px rgba(30, 144, 255, 0.1);
}

.form-input::placeholder {
  color: #adb5bd;
  font-size: 15px;
}

.form-input[readonly] {
  background: white;
}

/* Remember Checkbox */
.remember-section {
  margin: 24px 0;
}

.remember-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.remember-checkbox input[type="checkbox"] {
  display: none;
}

.checkbox-mark {
  width: 20px;
  height: 20px;
  border: 2px solid #e5e8eb;
  border-radius: 4px;
  margin-right: 8px;
  position: relative;
  transition: all 0.2s;
}

.remember-checkbox input[type="checkbox"]:checked + .checkbox-mark {
  background: #1e90ff;
  border-color: #1e90ff;
}

.remember-checkbox input[type="checkbox"]:checked + .checkbox-mark::after {
  content: '';
  position: absolute;
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.checkbox-label {
  font-size: 14px;
  color: #6b7684;
}

/* Login Button */
.login-btn {
  width: 100%;
  padding: 16px;
  background: #1e90ff;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
}

.login-btn:hover:not(:disabled) {
  background: #1877d1;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(30, 144, 255, 0.3);
}

.login-btn:active:not(:disabled) {
  transform: translateY(0);
}

.login-btn:disabled {
  background: #e5e8eb;
  color: #adb5bd;
  cursor: not-allowed;
}

/* Responsive */
@media (max-width: 480px) {
  ::v-deep .toss-login-modal .modal-dialog {
    max-width: calc(100% - 32px);
    margin: 16px;
  }

  .modal-header-wrapper {
    padding: 20px 20px 0;
  }

  .login-container {
    padding: 16px 20px 28px;
  }
}
</style>